export const dropDownData = {
    name: 'rowsPerPage',
    displayName: 'Select',
    placeHolder: 'Select size',
    isElementRequired: false,
    attributeType: 'SINGLE_SELECT',
    placeHolderDisabled: true,
    options: [
      {
        label: '5',
        value: 5,
        id: 1
      },
      {
        label: '10',
        value: 10,
        id: 2,
        selected: true
      },
      {
        label: '50',
        value: 50,
        id: 3
      },
      {
        label: '100',
        value: 100,
        id: 4
      }
    ],
    validation: {
      rule: {
        required: {
          isRequired: false,
          errorCode: 'MS102',
          errorMessage: ''
        }
      }
    }
  };
  